import { createFileRoute } from '@tanstack/react-router';

import { HostsContainer } from '@/features/hosts/containers';

export const Route = createFileRoute('/_layout/hosts/')({
  component: HostsContainer,
});
